import { blockConfig, blockMinimum, selectionEntities } from "./blocks";
import type { SceneNode } from "../scene/model";
import { alignmentCommand, transformNodes } from "../commands/node-transform";
import { bounds, selectionFrame } from "./geometry";
import { normalizeAngle, transformNativeNode } from "./transforms";

export function selectionDimensions(nodes: readonly SceneNode[]) {
  nodes = selectionEntities(nodes);
  if (nodes.length === 1)
    return {
      width: nodes[0]!.geometry.width!,
      height: nodes[0]!.geometry.height!,
    };
  const frame = selectionFrame(nodes);
  return frame ? { width: frame[0], height: frame[3] } : null;
}
export function resizeSelection(
  nodes: readonly SceneNode[],
  axis: "width" | "height",
  value: number,
): readonly SceneNode[] {
  nodes = selectionEntities(nodes);
  if (nodes.length === 1 && blockConfig(nodes[0]!)) {
    const min = blockMinimum(blockConfig(nodes[0]!)!)[axis];
    if (value < min)
      throw new Error(`Минимальный размер блока: ${Math.ceil(min)} px.`);
  }
  if (!Number.isFinite(value) || value < 1 || value > 1e6)
    throw new Error("Размер должен быть от 1 до 1 000 000 px.");
  if (nodes.length === 1)
    return [
      { ...nodes[0]!, geometry: { ...nodes[0]!.geometry, [axis]: value } },
    ];
  const frame = selectionFrame(nodes);
  if (!frame) return nodes;
  const x = axis === "width" ? value / frame[0] : 1,
    y = axis === "height" ? value / frame[3] : 1;
  return nodes.map((node) =>
    transformNativeNode(node, [
      x,
      0,
      0,
      y,
      frame[4] * (1 - x),
      frame[5] * (1 - y),
    ]),
  );
}
export function setNodeAngle(node: SceneNode, value: number): SceneNode {
  if (!Number.isFinite(value))
    throw new Error("Введите конечный угол поворота.");
  return {
    ...node,
    transform: { ...node.transform, rotation: normalizeAngle(value) },
  };
}
export function alignSelection(nodes: readonly SceneNode[], mode: string) {
  nodes = selectionEntities(nodes);
  const command = alignmentCommand(mode);
  return command
    ? transformNodes(
        nodes,
        command,
        new Map(nodes.map((node) => [node.id, bounds(node)])),
      )
    : nodes;
}
